<template>
  <div class="form-links mb-3 mb-md-0 px-i">
    <div class="form-links-wrapper container-fluid">
      <a v-if="showMerchantActions" class="btn btn-primary ihjoz-button form-links-wrapper-button" href="#invoice-confirmation-form">Confirm Payment</a>
      <router-link v-if="editableInvoice" :to="{ name: 'Edit Invoice', params: { hash: invoice.path_token } }" class="btn btn-primary ihjoz-button form-links-wrapper-item">
        <div class="form-links-wrapper-item-icon">
          <i class="demo-icon icon-pencil" />
        </div>
        <span class="form-links-wrapper-item-text">Edit</span>
      </router-link>
      <a :href="whatsappURL" class="btn btn-info ihjoz-button form-links-wrapper-item">
        <div class="form-links-wrapper-item-icon">
          <i class="demo-icon icon-enveloppe" />
        </div>
        <span class="form-links-wrapper-item-text">Share</span>
      </a>
      <button v-if="showMerchantActions" data-toggle="modal" data-target="#void-modal" type="button" class="btn btn-info ihjoz-button form-links-wrapper-item">
        <div class="form-links-wrapper-item-icon">
          <i class="demo-icon icon-ban" />
        </div>
        <span class="form-links-wrapper-item-text">Void</span>
      </button>
      <a :href="downloadLink" class="btn btn-info ihjoz-button form-links-wrapper-item">
        <div class="form-links-wrapper-item-icon">
          <i class="demo-icon icon-cloud-download" />
        </div>
        <span class="form-links-wrapper-item-text">Download</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "InvoiceActions",

  props: ["showMerchantActions", "invoice", "companyLegalName", "editableInvoice"],

  computed: {
    downloadLink () {
      return `/api/v4/invoices/${this.invoice.path_token}/download`;
    },

    whatsappURL () {
      let encodedText;
      if (this.invoice.subject) {
        encodedText = encodeURI(`${this.companyLegalName} has sent you an invoice for ${this.invoice.subject}. Click here to view and pay your invoice ${this.invoice.invoice_url}`);
      } else {
        encodedText = encodeURI(`${this.companyLegalName} has sent you an invoice. Click here to view and pay your invoice ${this.invoice.invoice_url}`);
      }

      if (this.invoice.customer_info && this.invoice.customer_info.customer_mobile_number) {
        return `https://wa.me/${this.invoice.customer_info.customer_mobile_number}?text=${encodedText}`;
      } else {
        return `https://wa.me/?text=${encodedText}`;
      }
    }
  }
};
</script>
